import React from 'react';
import { Menu } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../../hooks';
import { GoRepoForked, GoFile, GoPerson, GoOrganization } from "react-icons/go";
import './AdminMenu.scss';

export function AdminMenu() {

    //console.log(useAuth());
    const { pathname } = useLocation();
    const { user: { role } } = useAuth();
    const isAdmin = role === "ROLE_ADMIN";

    const isCurrentPath = (path) => {
        if (path === pathname) return true;
        return false;
    };

    return (
        <Menu fluid vertical icon text className='admin-menu'>

                <>
                    <Menu.Item as="Menu" className='admin-menu-sub'>
                       
                        Nodes
                        <GoRepoForked size="20" />
                    </Menu.Item>
                    <Menu.Item as={Link} to="/nodesPending/PENDING" active={isCurrentPath("/nodesPending/PENDING")}>
                    
                        Pending  Nodes
                    </Menu.Item>
                    <Menu.Item as={Link} to="/nodes/ACTIVE" active={isCurrentPath("/nodes/ACTIVE")}>
                        
                        Permissioned  Nodes
                    </Menu.Item>

                    <Menu.Item  as="Menu"    className='admin-menu-sub'>
                       
                        Market
                        <GoOrganization size="20" />
                    </Menu.Item>
                   
                    <Menu.Item as={Link} to="/market" active={isCurrentPath("/market")}>
                        
                        Azure
                    </Menu.Item>

                    <Menu.Item as="Menu"    className='admin-menu-sub'>
                       
                        
                       Requests     <GoFile size="20" />
                       
                    </Menu.Item>
                    {isAdmin && (
                    <Menu.Item as={Link} to="/adminRequestPermissionMain" active={isCurrentPath("/adminRequestPermissionMain")}>
                       
                        Form MainNet
                    </Menu.Item>
                    
                    )}
                    {isAdmin && (
                    <Menu.Item as={Link} to="/adminRequestPermissionOpen" active={isCurrentPath("/adminRequestPermissionOpen")}>
                       
                       Form Open Protest
                    </Menu.Item>
                     )}
                    <Menu.Item as={Link} to="/requestPendingPermission/PENDING" active={isCurrentPath("/requestPendingPermission/PENDING")}>
                     
                        Pending Forms
                    </Menu.Item>

                    <Menu.Item as={Link} to="/requestReadyPermission/CONFIRMED" active={isCurrentPath("/requestReadyPermission/CONFIRMED")}>
                     
                        Ready to Permission
                    </Menu.Item>

                    
                    {isAdmin && (
                    <Menu.Item as="Menu"  className='admin-menu-sub'>
                       
                        Users
                        <GoPerson size="20" />
                    </Menu.Item>
                     )}
                    

                    {isAdmin && (
                    <Menu.Item as={Link} to="/user" active={isCurrentPath("/user")}>
                       
                        Registre
                    </Menu.Item>
                     )}

                </>
        </Menu>
    );
}
